



















import { Vue, Component } from "vue-property-decorator";
import eventBus from "@/common/bus";

@Component
export default class App extends Vue {
  private loading = false;

  public created() {
    eventBus.$off("toastHandler").$on("toastHandler", (msg: string, color: string) => {
      this.$buefy.toast.open({
        duration: 3000,
        message: msg,
        type: color,
      });
    });
    eventBus.$off("loading").$on("loading", (loading: boolean) => {
      this.loading = loading;
    });
  }
}
